<template>
  <div>
      <div class="d-flex flex-stack flex-wrap">
          <div class="page-title d-flex flex-column me-3 mt-3"> 
              <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">Update Data DLL Template                
              </h1>
              <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                  <li class="breadcrumb-item text-gray-600">
                      <a href="#" class="text-gray-600 text-hover-primary">
                          <router-link :to="{ name: 'Home' }">Home</router-link>
                      </a>
                  </li> 
                  <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">Settings</router-link></li>  
                  <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'GeneralSettings' }">General Settings</router-link></li>  
                  <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'DLLTemplatesList' }">Data DLL Templates</router-link></li>  
                  <li class="breadcrumb-item text-gray-600">Update Data DLL Template</li> 
              </ul> 
          </div>  
          <div class="d-flex align-items-center py-1">
            <router-link to="/DLLTemplatesList">
                <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                <span class="ms-2 fs-7"> Return back to List</span>
                </button>
            </router-link> 
            &nbsp;
            <div class="dropdown">
                <button class="btn btn-light-info border border-info dropdown-toggle" type="button" @click="this.isOpenActionsDropdown = !this.isOpenActionsDropdown;">
                <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                </svg></span>
                    Actions
                </button>
                <ul class="dropdown-menu" :class="{ 'show': this.isOpenActionsDropdown }"> 
                    <li>
                        <a class="dropdown-item fs-4 text-danger" href="#" @click="deleteDllTemplate()">
                            <span class="svg-icon svg-icon-muted svg-icon-2 text-danger"><svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"/>
                                <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"/>
                                <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"/>
                                </svg>
                            </span>
                            Delete
                        </a>
                    </li>
                </ul>
            </div> 
          </div>
      </div>
      <div class="content flex-row-fluid mt-6" id="kt_content">
        <RequiredField></RequiredField>
        <div class="row">
            <div class="tab-content" id="myTabContent">
            <div class="card card-xxl-stretch tab-pane fade show active" id="kt_accounting_1" role="tabpanel">
                <div class="p-10">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                <div class="card-body pb-0">
                                    <form id="kt_ecommerce_settings_general_form"
                                        class="form fv-plugins-bootstrap5 fv-plugins-framework">                                
                                        <div class="fv-row mb-7 row">
                                            <div class="col-lg-12">
                                                <label class="fs-6 fw-bold form-label mt-3 required">
                                                    Template Name
                                                </label>
                                                <input type="text" class="form-control " name="code" v-model="form.template_name" required>
                                            </div>
                                            <div class="col-lg-12">
                                                <label class="fs-6 fw-bold form-label mt-3">
                                                    Description
                                                </label>
                                                <textarea rows="2" class="form-control " name="description" v-model="form.description"></textarea>
                                            </div>
                                            <div class="col-lg-12">
                                                <label class="fs-6 fw-bold form-label mt-3 required">
                                                    Is Active?
                                                </label>
                                                <div class="form-check mt-3 mb-2">
                                                    <input class="form-check-input" type="checkbox" value="" id="isActive" v-model="form.is_active" />
                                                    <small class="text-danger">If this option is checked as passive, DLL will not be able to use for Data Import.</small> 
                                                </div> 
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                <div class="card-body pb-0">
                                    <form id="kt_ecommerce_settings_general_form"
                                        class="form fv-plugins-bootstrap5 fv-plugins-framework">
                                        <div class="fv-row mb-7 row"> 
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mb-0 required">
                                                Module
                                            </label>
                                            <Select2 v-model="form.module_type" :options="moduleType" :settings="{width: '100%'}" />
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mb-0 required">
                                                DLL Type
                                            </label>
                                            <Select2 v-model="form.dll_type" :options="dllTypes" :settings="{width: '100%'}" />
                                        </div>
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-2">
                                                <span>DLL Upload</span>
                                            </label> 
                                             <DxFileUploader
                                                  multiple="false"
                                                  upload-mode="instantly"
                                                  :visible="true"
                                                  :upload-headers="getUploadHeaders()"
                                                  upload-url="/api/DLLTemplates/UploadDLLFile"
                                                  :ref="'fileUploader'"
                                                  :on-uploaded="onUploadCompleted"
                                                  uploadButtonText="Upload DLL File"
                                              />

                                              <div class="alert alert-dismissible bg-success d-flex flex-column flex-sm-row w-100 p-5 mb-10" v-if="form.file_name != null && form.file_name != undefined && form.file_name != ''">
                                                <span class="svg-icon svg-icon-dark svg-icon-2hx">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
                                                        <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>
                                                    </svg>
                                                </span>
                                                <div class="d-flex flex-column ps-4 pe-0 pe-sm-10">
                                                    <h4 class="fw-semibold">A working DLL file found!</h4>
                                                    <span><i class="fas fa-cogs text-gray-800"></i> <strong> {{ form.file_name }} </strong> has been attached to this template. If you upload an another DLL file, old version will be removed.</span>
                                                </div>
                                              </div>                                              
                                            </div>
                                        </div> 
                                    </form>
                                </div>
                            </div>
                        </div> 
                        <div class="col-lg-12">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-primary" @click="this.saveData()" data-kt-indicator="on">
                                    <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                    <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                    </svg>
                                    </span> 
                                    <strong v-if="!this.isProgressing"> Update DLL </strong> 
                                        <span class="indicator-progress" v-if="this.isProgressing">
                                            Saving Data... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span> 
                                </button>
                            </div>                 
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
      </div>
  </div>
</template>


<script>
// Component Alias: `DLU001`
import axios from 'axios' 
  

import { DxFileUploader } from 'devextreme-vue/file-uploader';
// import Swal from 'sweetalert2';
 
export default {
  name: "DLLTemplateCreate",
  components: {
    DxFileUploader
  },
  data() {
    return {
        lists: [],
        isProgressing: false,
        form: { 
            template_name: null,
            file_name: null,
            description: null,
            is_active: true,
            dll_type: 1,
            module_type: 1
        },
        dllTypes: [
            { id: 0, text: 'SELECT A TYPE'},
            { id: 1, text: 'EXCEL/XLS/XLSX'},
            { id: 2, text: 'XML'}
        ],
        isOpenActionsDropdown:false,
        moduleType: [
            { id: 1, text: 'Insurance '},
            { id: 2, text: 'General'}
        ]
    };
  },
  methods: {
    getData(){
        const params = {
            id: this.$getSessionStorage("record_id"),
            session_id: this.$getUser().session_id,
        };
        axios.post('/api/DLLTemplates/GetDLLTemplateById', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(response.data != null){  
                response.data.is_active = response.data.is_active == 1 ? true : false;
                this.form = response.data;
            }
        })
        .catch(function (error) {
            console.error(error);
        });         
    },
    saveData(){
        this.isProgressing = true;
        const params = this.form; 
        const that = this;
        params.session_id = this.$getUser().session_id;
        params.is_active = params.is_active == true ? 1 : 0;
        axios.post('/api/DLLTemplates/UpdateDLLTemplate', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(response.data != null && response.data.length == 36){  
                this.$setSessionStorage("record_id", response.data);
                this.$swal("Success", "Data saved succesfully..!", 'success');  
                this.$setSessionStorage('refreshList', true);    
                this.$router.push({ name: 'DLLTemplatesUpdate' });
                this.getData();
            }
        })
        .catch(function (error) {
            console.error(error);
            this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error");   
        })
        .finally(function () { 
            setTimeout(() => {
                that.isProgressing = false;
            }, 500);
        });   
    },
    getUploadHeaders(){
        return { 
            session_id: this.$getUser().session_id,
            id: this.$getSessionStorage("record_id")
        };
    },
    onUploadCompleted(){
      this.$swal("Success", "DLL Uploaded Successfully..!", 'success'); 
      this.getData();
    },
    deleteDllTemplate(){
         this.$swal.fire({
            title: "Are you sure you want to remove this item?",
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "DELETE",
            icon: 'info'
        }).then((result) => {
            if (result.isConfirmed) {
                const params = {
                    session_id : this.$getUser().session_id,
                    id : this.form.id
                };
                axios.post('/api/DLLTemplates/DeleteDLLTemplate', params, {'Content-Type': 'application/json'})
                .then((response) => { 
                    if(response.data.error == null || response.data.error == '' || response.data.error == undefined){  
                        this.$setSessionStorage('refreshList', true);  
                        this.$router.push({ name: 'DLLTemplatesList' });
                    }
                }).catch(function (error) {
                    console.error(error);
                })
            }
        })
    }
  },
  created() {
    this.$setSessionStorage('refreshList', true);
    this.getData();
  }
}; 
</script>